"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOP_AREA_BANNER_DIALOG_MESSAGE = exports.TOP_AREA_BANNER_DIALOG_LOADER = exports.TOP_AREA_BANNER_DIALOG_GREETING_MESSAGE = exports.TOP_AREA_BANNER_DIALOG = void 0;
const TOP_AREA_BANNER_DIALOG = exports.TOP_AREA_BANNER_DIALOG = 'top-area-banner-dialog';
const TOP_AREA_BANNER_DIALOG_GREETING_MESSAGE = exports.TOP_AREA_BANNER_DIALOG_GREETING_MESSAGE = 'top-area-banner-dialog-greeting-message';
const TOP_AREA_BANNER_DIALOG_MESSAGE = exports.TOP_AREA_BANNER_DIALOG_MESSAGE = 'top-area-banner-dialog-message';
const TOP_AREA_BANNER_DIALOG_LOADER = exports.TOP_AREA_BANNER_DIALOG_LOADER = 'top-area-banner-dialog-loader';
